const TAGS = ['SPAN', 'DIV', 'STRIKE'];

const extractPrice = (priceElement) => {
  const price = priceElement.textContent;
  return price;
};

const changePrice = (priceElement, { convertedPrice }) => {
  priceElement.textContent = convertedPrice;
};

const matchType = (selector) => TAGS.includes(selector.tagName);

export default { matchType, extractPrice, changePrice, name: 'plainText' };
